/* Stix PDP Stock-Aware Picker — Option D (Cascading Dropdowns)
 * -------------------------------------------------------------
 * Builds native <select> for ALL dimensions of the merged catalog. Inline
 * hints per value where we recognize the name.
 *
 * 2026-10-08 — layered test `pdp_picker_autoselect` (PDP-007, Brad's ask):
 *   control    = arm D exactly as shipped 2026-07-30.
 *   autoselect = when a shopper changes an option and the resulting combo is
 *                sold out (or not offered), the options BELOW it auto-switch
 *                to the nearest in-stock combo. Hand and Shaft Length are
 *                never auto-changed (fit-critical), the option the shopper
 *                just picked is never overridden, and a one-line note says
 *                what changed and any price difference.
 * Assignment is config-driven (shop.metafields.cro.test_config) with the same
 * cookie scheme as pdp_wallet_buttons: cro_<test>_v<cookie_version>, so the arm
 * also rides properties[_cro_arms] on wallet orders. Inert unless the config
 * entry exists with status 'active'. QA: ?cl_autoselect=1 | 0 (not persisted). */
(function () {
  'use strict';
  var ARM = 'd';

  var HINT_MAP = {
    'shaft length': { 'Standard': "Your height 5'8\" – 6'2\"", 'Tall': "Your height 6'2\" or taller", 'Short': "Your height under 5'8\"", 'Petite': "Your height under 5'4\"" },
    'length':       { 'Standard': "Your height 5'8\" – 6'2\"", 'Tall': "Your height 6'2\" or taller", 'Short': "Your height under 5'8\"" },
    'shaft flex':   { 'Stiff': 'You hit driver ~230 yds', 'Regular': 'You hit driver ~200 yds', 'Active': 'You hit driver under 200 yds' },
    'flex':         { 'Stiff': 'You hit driver ~230 yds', 'Regular': 'You hit driver ~200 yds', 'Active': 'You hit driver under 200 yds' },
    'shaft material': { 'Graphite': 'lighter, easier swing', 'Steel': 'heavier, more feedback' },
    'material':       { 'Graphite': 'lighter, easier swing', 'Steel': 'heavier, more feedback' },
    'include bag':    { 'With Bag': '+$100', 'No Bag': 'no bag, base price' },
    'bag':            { 'With Bag': '+$100', 'No Bag': 'no bag, base price' }
  };
  function hintFor(name, value) {
    var k = (name || '').toLowerCase();
    return (HINT_MAP[k] && HINT_MAP[k][value]) || '';
  }
  function helpFor(name) {
    /* Subtitles dropped per Gabe — dropdown labels + inline hints carry enough
       context. Function kept so the mount template still calls it safely. */
    return '';
  }

  /* Priority order: Length and Hand first */
  /* Order: Hand → Shaft Length → Shaft Flex → Shaft Material → Include Bag.
     Per Gabe — the two 'Shaft *' options sit next to each other. */
  var PRIORITY = ['hand', 'dexterity', 'handedness', 'shaft length', 'length', 'shaft flex', 'flex', 'shaft material', 'material', 'include bag', 'bag'];

  /* ---- pdp_picker_autoselect: arm assignment -------------------------- */
  var AS_TEST_ID = 'pdp_picker_autoselect';
  var asArm = null; /* null = test not running → plain arm D */
  function assignAutoselect() {
    try {
      var qa = new URLSearchParams(location.search).get('cl_autoselect');
      if (qa === '1') return (asArm = 'autoselect');
      if (qa === '0') return (asArm = 'control');
    } catch (e) {}
    try {
      var cfg = (window.STIX_CRO_CONFIG || {})[AS_TEST_ID];
      if (!cfg || cfg.status !== 'active' || navigator.webdriver) return null;
      var variants = cfg.variants || [];
      var valid = variants.map(function (v) { return v.label; });
      var COOKIE = 'cro_' + AS_TEST_ID + '_v' + (cfg.cookie_version || 1);
      var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      var a = m ? decodeURIComponent(m[1]) : null;
      if (!a || valid.indexOf(a) === -1) {
        var total = 0; variants.forEach(function (v) { total += (v.weight || 0); });
        var r = Math.random() * total, cum = 0; a = null;
        for (var j = 0; j < variants.length; j++) { cum += variants[j].weight || 0; if (r < cum) { a = variants[j].label; break; } }
        if (!a) a = 'control';
        var d = new Date(); d.setDate(d.getDate() + (cfg.cookie_days || 30));
        document.cookie = COOKIE + '=' + encodeURIComponent(a) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
      }
      asArm = a;
      if (window.stixCroExpose) window.stixCroExpose(AS_TEST_ID, a, { page_type: 'pdp' });
      /* Wallet buy-it-now drops cart attributes; keep _cro_arms current (the
         main-product.liquid script may have built it before this cookie existed). */
      var inp = document.querySelector('input[name="properties[_cro_arms]"]');
      if (inp) {
        var arms = {}; try { arms = JSON.parse(inp.value) || {}; } catch (e) {}
        arms['cro_test_' + AS_TEST_ID] = a; inp.value = JSON.stringify(arms);
      }
      return a;
    } catch (e) { return null; }
  }

  /* ---- pdp_picker_autoselect: pick the nearest in-stock combo ----------
     Pure function (exported on window.StixPickerAutoselect for QA/tests).
     catalog: {optionNames, variants[{options, available, price}]}
     order:   option names top→bottom as rendered
     sel:     current selection, AFTER the shopper's change
     changed: the option name the shopper just changed
     prevSel: selection before the change (price shown in the note is vs this)
     Returns null when the combo is already in stock or nothing qualifies,
     else {sel, variant, changes:[{name, from, to}], priceDelta}. */
  function pickAutoselect(catalog, order, sel, changed, prevSel) {
    var names = catalog.optionNames;
    function idx(n) { return names.indexOf(n); }
    function match(v, s) { for (var i = 0; i < names.length; i++) if (v.options[i] !== s[names[i]]) return false; return true; }
    var cur = null;
    for (var c = 0; c < catalog.variants.length; c++) if (match(catalog.variants[c], sel)) { cur = catalog.variants[c]; break; }
    if (cur && cur.available) return null;

    var k = order.indexOf(changed);
    var locked = order.slice(0, k + 1);                      /* shopper's pick + everything above it */
    order.forEach(function (n) { if (/hand|dex|length/i.test(n) && locked.indexOf(n) < 0) locked.push(n); }); /* fit-critical: never auto-change */
    var free = order.filter(function (n) { return locked.indexOf(n) < 0; });
    if (!free.length) return null;

    var FLEX = { 'Active': 0, 'Senior': 0, 'Regular': 1, 'Stiff': 2, 'Extra Stiff': 3, 'X-Stiff': 3 };
    var prev = null;
    if (prevSel) for (var pv = 0; pv < catalog.variants.length; pv++) if (match(catalog.variants[pv], prevSel)) { prev = catalog.variants[pv]; break; }
    var curPrice = prev ? prev.price : (cur ? cur.price : null);
    var best = null, bestKey = null;
    catalog.variants.forEach(function (v) {
      if (!v.available) return;
      for (var i = 0; i < locked.length; i++) { var li = idx(locked[i]); if (li >= 0 && v.options[li] !== sel[locked[i]]) return; }
      /* Cost: changing an option HIGHER in the list costs more (bag before
         material before flex). Each free option gets a power-of-two weight so
         one higher change always outweighs any number of lower ones. */
      var cost = 0, flexDist = 0, tooFar = false;
      free.forEach(function (n, fi) {
        var vi = idx(n);
        if (v.options[vi] !== sel[n]) {
          cost += Math.pow(2, free.length - 1 - fi);
          if (/flex/i.test(n)) {
            /* Flex is fit: move at most ONE step (Regular↔Stiff), never an
               unknown value. Further than that → leave it to the OOS card. */
            if (!(sel[n] in FLEX) || !(v.options[vi] in FLEX)) { tooFar = true; return; }
            var dist = Math.abs(FLEX[v.options[vi]] - FLEX[sel[n]]);
            if (dist > 1) tooFar = true;
            flexDist += dist;
          }
        }
      });
      if (tooFar) return;
      var priceDiff = curPrice == null ? 0 : Math.abs(v.price - curPrice);
      var key = [cost, flexDist, priceDiff];
      if (!bestKey || key[0] < bestKey[0] || (key[0] === bestKey[0] && (key[1] < bestKey[1] || (key[1] === bestKey[1] && key[2] < bestKey[2])))) { best = v; bestKey = key; }
    });
    if (!best) return null;
    var out = {}, changes = [];
    names.forEach(function (n, i) {
      out[n] = best.options[i];
      if (best.options[i] !== sel[n]) changes.push({ name: n, from: sel[n], to: best.options[i] });
    });
    return { sel: out, variant: best, changes: changes, priceDelta: curPrice == null ? null : best.price - curPrice };
  }
  window.StixPickerAutoselect = { pick: pickAutoselect };

  function autoselectNote(res) {
    var parts = res.changes.map(function (c) { return c.to; });
    var froms = res.changes.map(function (c) { return c.from; }).filter(Boolean);
    var txt = 'Switched to ' + parts.join(', ');
    if (res.priceDelta) txt += ' (' + (res.priceDelta > 0 ? '+' : '−') + '$' + Math.round(Math.abs(res.priceDelta)) + ')';
    txt += froms.length ? '. ' + froms.join(', ') + ' is sold out with these options.' : ', the closest combo in stock.';
    return txt;
  }

  function maybeInit() {
    var arm = window.STIX_TEST && window.STIX_TEST['pdp_stockaware_picker'];
    if (arm !== ARM) return;
    if (!window.StixPicker || !window.StixPicker.catalog) { setTimeout(maybeInit, 50); return; }
    init();
  }
  document.addEventListener('cl-picker-router:activated', function (e) { if (e.detail && e.detail.arm === ARM) maybeInit(); });
  document.addEventListener('cl-picker-catalog-ready', maybeInit);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', maybeInit); } else { maybeInit(); }

  function init() {
    var root = document.querySelector('[data-cl-picker-D]');
    if (!root) return;
    if (root.dataset.clInited) return;
    root.dataset.clInited = '1';
    assignAutoselect();

    var catalog = StixPicker.catalog;
    var mount = root.querySelector('[data-cl-options-mount]');
    var oosMount = root.querySelector('[data-cl-oos-mount]');
    var oosHero = StixPicker.attachOosHero(oosMount, ARM);
    var noteEl = null;
    if (asArm === 'autoselect') {
      noteEl = document.createElement('p');
      noteEl.className = 'cl-picker-D__autonote';
      noteEl.setAttribute('role', 'status');
      noteEl.setAttribute('aria-live', 'polite');
      noteEl.hidden = true;
      oosMount.parentNode.insertBefore(noteEl, oosMount);
      if (!document.getElementById('cl-autonote-css')) {
        var st = document.createElement('style'); st.id = 'cl-autonote-css';
        st.textContent = '.cl-picker-D__autonote{margin:4px 0 12px;padding:10px 12px;border-left:3px solid var(--cl-accent,#fdb827);background:var(--cl-bg-soft,rgba(255,255,255,.06));color:var(--cl-fg,#fff);font-size:13px;line-height:1.4}';
        document.head.appendChild(st);
      }
    }

    /* Order dropdowns by priority */
    var order = [];
    PRIORITY.forEach(function (k) {
      var m = catalog.optionNames.find(function (n) { return n.toLowerCase() === k; });
      if (m && order.indexOf(m) === -1) order.push(m);
    });
    catalog.optionNames.forEach(function (n) { if (order.indexOf(n) === -1) order.push(n); });

    mount.innerHTML = order.map(function (name) {
      var help = helpFor(name);
      return '<div class="cl-picker-D__option" data-cl-d-option="' + name + '">' +
        '<label class="cl-picker-D__label"><span>' + name + '</span><span class="cl-picker-D__avail" data-cl-d-avail></span></label>' +
        (help ? '<span class="cl-picker-D__help">' + help + '</span>' : '') +
        '<div class="cl-css-select-mount" data-cl-d-mount data-cl-option-name="' + name + '"></div>' +
        '</div>';
    }).join('');

    /* Build a custom CSS dropdown for each option */
    var dropdowns = {};
    order.forEach(function (name) {
      var mountDiv = root.querySelector('[data-cl-d-mount][data-cl-option-name="' + name + '"]');
      dropdowns[name] = StixPicker.makeDropdown(mountDiv, {
        onChange: function (val) {
          var prevSel = Object.assign({}, sel);
          sel[name] = val;
          if (noteEl) noteEl.hidden = true;
          if (asArm === 'autoselect') {
            var res = pickAutoselect(catalog, order, sel, name, prevSel);
            if (res) {
              sel = res.sel;
              noteEl.textContent = autoselectNote(res);
              noteEl.hidden = false;
              try {
                (window.dataLayer = window.dataLayer || []).push({
                  event: 'stix.picker_autoselect',
                  cl_test_id: AS_TEST_ID, cl_test_variant: asArm,
                  changed_option: name,
                  switched: res.changes.map(function (c) { return c.name + ':' + c.from + '>' + c.to; }).join('|'),
                  price_delta: res.priceDelta, variant_id: res.variant.id
                });
              } catch (e) {}
            }
          }
          applyAndFire();
        }
      });
    });

    /* All values per option (in catalog appearance order) */
    var allVals = {};
    catalog.optionNames.forEach(function (name, i) {
      allVals[name] = [];
      catalog.variants.forEach(function (v) {
        if (v.options[i] && allVals[name].indexOf(v.options[i]) === -1) allVals[name].push(v.options[i]);
      });
    });

    function bestStatusFor(optionName, value, locked) {
      var idx = catalog.optionNames.indexOf(optionName);
      var best = 'not-offered';
      catalog.variants.forEach(function (v) {
        if (v.options[idx] !== value) return;
        for (var k in locked) {
          var li = catalog.optionNames.indexOf(k);
          if (li >= 0 && v.options[li] !== locked[k]) return;
        }
        if (v.available) best = 'in-stock';
        else if (best !== 'in-stock') best = 'oos';
      });
      return best;
    }

    var sel = StixPicker.initialSel();

    function render() {
      var lockedSoFar = {};
      order.forEach(function (name) {
        var availEl = root.querySelector('[data-cl-d-option="' + name + '"] [data-cl-d-avail]');
        var inStockCount = 0, oosCount = 0, notOfferedCount = 0;
        var list = [];
        allVals[name].forEach(function (val) {
          var status = bestStatusFor(name, val, lockedSoFar);
          if (status === 'not-offered') { notOfferedCount++; return; }
          list.push({
            value: val,
            label: val,
            sub: hintFor(name, val) || (status === 'oos' ? 'out of stock' : ''),
            status: status
          });
          if (status === 'oos') oosCount++; else inStockCount++;
        });
        if (availEl) {
          var total = inStockCount + oosCount;
          if (total === 0) { availEl.textContent = 'no match'; availEl.className = 'cl-picker-D__avail has-oos'; }
          else if (oosCount === 0 && notOfferedCount === 0) { availEl.textContent = inStockCount + ' in stock'; availEl.className = 'cl-picker-D__avail fully-stocked'; }
          else if (oosCount === 0) { availEl.textContent = inStockCount + ' in stock · ' + notOfferedCount + ' not offered'; availEl.className = 'cl-picker-D__avail'; }
          else { availEl.textContent = inStockCount + ' in stock · ' + oosCount + ' sold out'; availEl.className = 'cl-picker-D__avail has-oos'; }
        }
        var validVals = list.map(function (o) { return o.value; });
        if (validVals.indexOf(sel[name]) < 0) {
          var firstInStock = list.find(function (o) { return o.status === 'in-stock'; });
          sel[name] = firstInStock ? firstInStock.value : (validVals[0] || sel[name]);
        }
        dropdowns[name].setOptions(list, sel[name]);
        lockedSoFar[name] = sel[name];
      });
      oosHero.update(sel, StixPicker.variantStatus(sel));
    }

    function applyAndFire() {
      StixPicker.applyVariant(sel);
      StixPicker.fireVariantEvents(sel, ARM);
      render();
    }

    /* Dropdown change handlers wired in makeDropdown's onChange option above */
    root.addEventListener('oos-hero:swap', function (e) {
      sel = Object.assign({}, e.detail.sel);
      applyAndFire();
    });

    render();
  }
})();
